import React from "react";
import { AppProvider } from "@context/AppContext";

import '@fontsource/abeezee';
import '@fontsource/poppins';

// Global styles
import "./src/styles/normalize.css";
import "./src/styles/global.css";
import "./src/styles/cookies.css";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
